import Layout from '@/layout'

const organizationRoute = [
    {
        path: '/company',
        component: Layout,
        redirect: '/company/company',
        name: 'organizationChart',
        meta: {
          title: '组织架构',
          icon: 'tree',
          roles: ['admin']
        },
        children: [
          {
            path: 'company',
            name: 'company',
            component: () => import('@/views/company/company'),
            meta: {
              title: '公司',
              icon: 'gongsi'
            }
          },
          {
            path: 'department',
            name: 'department',
            component: () => import('@/views/company/department'),
            meta: {
              title: '部门',
              icon: 'bumen'
            }
          },
          {
            path: 'jobPost',
            name: 'jobPost',
            component: () => import('@/views/company/jobPost'),
            meta: {
              title: '岗位',
              icon: 'jurassic_role'
            }
          },
          {
            path: 'employee',
            name: 'employee',
            component: () => import('@/views/company/employee'),
            meta: {
              title: '员工',
              icon: 'employee'
            }
          }
        ]
      }
];
export default organizationRoute


// WEBPACK FOOTER //
// ./src/router/modules/organization.js